<template>
  <div>
    <TopBar :mode="mode" @toggle="$emit('toggle')">
      <span class="text-[21px] font-semibold custom:text-lg xl:hidden">
        Beta tools automatic AI-based content generation tool</span
      >
    </TopBar>
    <div class="p-4">
      <div class="mb-4 hidden xl:flex">
        <span class="text-[21px] font-semibold custom:text-lg">
          Beta tools automatic AI-based content generation tool</span
        >
      </div>
      <div
        class="rounded-xl shadow-card"
        :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
      >
        <nav
          class="border-b flex space-x-4 px-1 custom:space-x-2 flex-wrap"
          :class="mode === 'dark' ? 'border-dark-50' : ''"
        >
          <div
            v-for="(tab, key) in tabs"
            :key="key"
            class="inline-flex items-center relative py-4 px-2 text-[15px] nav-tab cursor-pointer custom:px-2 text-center"
            :class="
              activeSection === tab
                ? 'active font-medium'
                : mode === 'dark'
                ? 'text-dark-15'
                : 'text-gray-500'
            "
            @click="setActiveSection(tab)"
          >
            {{ tab }}
          </div>
        </nav>
        <div class="p-4">
          <div
            class="rounded-xl border"
            :class="mode === 'dark' ? 'border-dark-50' : ''"
          >
            <template
              v-if="
                [
                  tabs.HCUPR,
                  tabs.NamingSpot,
                  tabs.FeaturedSnippet,
                  tabs.QueryIntentFinder,
                  tabs.OutlineSubheaders,
                  tabs.TopicalCluster,
                ].includes(activeSection)
              "
            >
              <div
                class="border-b flex space-x-4 px-1 custom:space-x-2"
                :class="mode === 'dark' ? 'border-dark-50' : ''"
              >
                <div
                  class="inline-flex items-center relative p-4 text-[15px] nav-tab cursor-pointer custom:px-2"
                  :class="
                    activeTab === 'prompt'
                      ? 'active font-medium'
                      : mode === 'dark'
                      ? 'text-dark-15'
                      : 'text-gray-500'
                  "
                  @click="setActiveTab('prompt')"
                >
                  Prompt
                </div>
                <div
                  v-if="
                    ((activeSection === tabs.HCUPR ||
                      activeSection === tabs.QueryIntentFinder ||
                      activeSection === tabs.OutlineSubheaders ||
                      activeSection === tabs.TopicalCluster ||
                      activeSection === tabs.FeaturedSnippet) &&
                      Object.keys(result).length > 0) ||
                    answeres.length > 0
                  "
                  class="inline-flex items-center relative p-4 text-[15px] nav-tab cursor-pointer custom:px-2"
                  :class="
                    activeTab === 'result'
                      ? 'active font-medium'
                      : mode === 'dark'
                      ? 'text-dark-15'
                      : 'text-gray-500'
                  "
                  @click="setActiveTab('result')"
                >
                  Results
                </div>
              </div>
            </template>
            <div class="p-4">
              <div v-if="activeTab === 'prompt'" class="grid gap-4">
                <div>
                  <template v-if="activeSection === tabs.HCUPR">
                    <div class="grid grid-cols-2 gap-4 xs:grid-cols-1">
                      <div class="flex-1">
                        <Multiselect
                          class="form-field"
                          v-model="language"
                          :options="languages"
                          placeholder="Choose language"
                          :searchable="true"
                          :canDeselect="true"
                        ></Multiselect>
                      </div>
                      <div class="flex-1">
                        <div class="relative">
                          <input
                            type="text"
                            class="form-field"
                            id="Topic"
                            placeholder="Exact match query"
                            v-model="topic"
                            @focus="showResultsSuggestion"
                            v-click-outside="hideEMQSuggestion"
                            autocomplete="off"
                          />
                          <DropdownSuggestions
                            :onOnSelect="selectEMQ"
                            :show="showSuggestedEMQ"
                            :results="suggestedReports"
                            :mode="mode"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="border rounded-xl mt-4"
                      :class="mode === 'dark' ? 'border-dark-50' : ''"
                    >
                      <div
                        class="px-3 py-3.5 border-b"
                        :class="mode === 'dark' ? 'border-dark-50' : ''"
                        v-if="promptKeys.length > 0"
                      >
                        <span class="font-semibold text-[17px] leading-none"
                          >Helpful content update</span
                        >
                      </div>
                      <div class="grid gap-4 p-4">
                        <template v-for="key in promptKeys" :key="key">
                          <template v-if="prompts[key]['type'] === 'HCU'">
                            <div class="checkbox">
                              <input
                                type="checkbox"
                                name="prompt"
                                :value="key"
                                :id="key"
                                @change="handlePromptChanged"
                                :disabled="userStore.isloading"
                                :checked="checkedPrompts.includes(key)"
                              />
                              <label :for="key">
                                {{ prompts[key]["title"] }}
                              </label>
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                    <div
                      class="border rounded-xl mt-4"
                      :class="mode === 'dark' ? 'border-dark-50' : ''"
                    >
                      <div
                        class="px-3 py-3.5 border-b"
                        :class="mode === 'dark' ? 'border-dark-50' : ''"
                        v-if="promptKeys.length > 0"
                      >
                        <span class="font-semibold text-[17px] leading-none"
                          >Google review AI</span
                        >
                      </div>
                      <div class="grid gap-4 p-4">
                        <template v-for="key in promptKeys" :key="key">
                          <template v-if="prompts[key]['type'] === 'PR'">
                            <div class="checkbox">
                              <input
                                type="checkbox"
                                name="prompt"
                                :value="key"
                                :id="key"
                                @change="handlePromptChanged"
                                :disabled="userStore.isloading"
                                :checked="checkedPrompts.includes(key)"
                              />
                              <label :for="key">
                                {{ prompts[key]["title"] }}
                              </label>
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                  </template>
                  <template v-if="activeSection === tabs.FeaturedSnippet">
                    <div
                      class="border rounded-xl"
                      :class="mode === 'dark' ? 'border-dark-50' : ''"
                    >
                      <div
                        class="px-4 py-3.5 border-b"
                        :class="mode === 'dark' ? 'border-dark-50' : ''"
                      >
                        <h5 class="font-semibold text-[17px] leading-none mb-1">
                          Win the featured snippet
                        </h5>
                        <p
                          class="text-[15px]"
                          :class="
                            mode === 'dark' ? 'text-dark-15' : 'text-gray-600'
                          "
                        >
                          Our AI will write the best answer or explanation to a
                          query intent or search intent of your EMQ.
                        </p>
                      </div>
                      <div class="flex items-center gap-4 p-4">
                        <div class="relative flex-1">
                          <input
                            type="text"
                            class="form-field"
                            id="Topic"
                            placeholder="Exact match query"
                            v-model="topic"
                            @focus="showResultsSuggestion"
                            v-click-outside="hideEMQSuggestion"
                            autocomplete="off"
                          />
                          <DropdownSuggestions
                            :onOnSelect="selectEMQ"
                            :show="showSuggestedEMQ"
                            :results="suggestedReports"
                            :mode="mode"
                          />
                        </div>
                        <div class="flex-1">
                          <Multiselect
                            class="form-field"
                            v-model="language"
                            :options="languages"
                            placeholder="Choose language"
                            :searchable="true"
                            :canDeselect="true"
                          ></Multiselect>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="activeSection === tabs.NamingSpot">
                    <div
                      class="border rounded-xl"
                      :class="mode === 'dark' ? 'border-dark-50' : ''"
                    >
                      <div
                        class="px-4 py-3.5 border-b"
                        :class="mode === 'dark' ? 'border-dark-50' : ''"
                        v-if="promptKeys.length > 0"
                      >
                        <span class="font-semibold text-[17px] leading-none"
                          >Page naming spots</span
                        >
                      </div>
                      <div class="grid gap-4 p-4">
                        <template v-for="key in promptKeys" :key="key">
                          <template v-if="prompts[key]['type'] === 'AI'">
                            <div class="checkbox">
                              <input
                                type="checkbox"
                                name="prompt"
                                :value="key"
                                id="url"
                                @change="handleAIPromptChanged('url', $event)"
                                :disabled="userStore.isloading"
                                :checked="
                                  checkedPrompts.includes(key) &&
                                  selectedAIPrompt === 'url'
                                "
                              />
                              <label for="url" class="flex items-center gap-1">
                                URL
                                <Info
                                  :size="18"
                                  :stroke-width="1.75"
                                  v-tooltip="{
                                    content: `Keyword Spy Report required`,
                                    placement: 'right',
                                    distance: 10,
                                  }"
                                />
                              </label>
                            </div>
                            <div class="checkbox">
                              <input
                                type="checkbox"
                                name="prompt"
                                :value="key"
                                id="tt"
                                @change="handleAIPromptChanged('tt', $event)"
                                :disabled="userStore.isloading"
                                :checked="
                                  checkedPrompts.includes(key) &&
                                  selectedAIPrompt === 'tt'
                                "
                              />
                              <label for="tt">Title</label>
                            </div>
                            <div class="checkbox">
                              <input
                                type="checkbox"
                                name="prompt"
                                :value="key"
                                id="md"
                                @change="handleAIPromptChanged('md', $event)"
                                :disabled="userStore.isloading"
                                :checked="
                                  checkedPrompts.includes(key) &&
                                  selectedAIPrompt === 'md'
                                "
                              />
                              <label for="md">Meta description</label>
                            </div>
                            <div class="checkbox">
                              <input
                                type="checkbox"
                                name="prompt"
                                :value="key"
                                id="h1"
                                @change="handleAIPromptChanged('h1', $event)"
                                :disabled="userStore.isloading"
                                :checked="
                                  checkedPrompts.includes(key) &&
                                  selectedAIPrompt === 'h1'
                                "
                              />
                              <label for="h1">H1</label>
                            </div>
                            <div class="checkbox">
                              <input
                                type="checkbox"
                                name="prompt"
                                :value="key"
                                id="h1v2"
                                @change="handleAIPromptChanged('h1v2', $event)"
                                :disabled="userStore.isloading"
                                :checked="
                                  checkedPrompts.includes(key) &&
                                  selectedAIPrompt === 'h1v2'
                                "
                              />
                              <label for="h1v2" class="flex items-center gap-1">
                                H1 (version 2)
                                <Info
                                  :size="18"
                                  :stroke-width="1.75"
                                  v-tooltip="{
                                    content: `Keyword Spy Report required`,
                                    placement: 'right',
                                    distance: 10,
                                  }"
                                />
                              </label>
                            </div>
                            <div class="checkbox">
                              <input
                                type="checkbox"
                                name="prompt"
                                :value="key"
                                id="mdv2"
                                @change="handleAIPromptChanged('mdv2', $event)"
                                :disabled="userStore.isloading"
                                :checked="
                                  checkedPrompts.includes(key) &&
                                  selectedAIPrompt === 'mdv2'
                                "
                              />
                              <label for="mdv2">
                                Meta description (version 2)
                              </label>
                            </div>
                            <div class="grid gap-4">
                              <div
                                :class="
                                  checkedPrompts.includes(key)
                                    ? 'flex-1 grid gap-4'
                                    : 'hidden'
                                "
                              >
                                <div
                                  v-if="
                                    checkedPrompts[0] === '14' &&
                                    (selectedAIPrompt === 'url' ||
                                      selectedAIPrompt === 'h1v2')
                                  "
                                >
                                  <Multiselect
                                    v-model="selectedEMQ"
                                    :placeholder="
                                      (selectedAIPrompt &&
                                        aiPrompts[selectedAIPrompt][
                                          'topicPlaceholder'
                                        ]) ||
                                      ''
                                    "
                                    label="query"
                                    valueProp="uuid"
                                    :searchable="true"
                                    :options="reports || []"
                                    @change="handleSelectEMQ"
                                    class="form-field"
                                  >
                                  </Multiselect>
                                  <div
                                    v-if="
                                      (!selectedEMQ || selectedEMQ === '') &&
                                      showSelectQueryError
                                    "
                                    class="text-sm mt-1 text-danger-100"
                                  >
                                    Please select an EMQ
                                  </div>
                                </div>
                                <div v-else class="relative">
                                  <template v-if="selectedAIPrompt === 'mdv2'">
                                    <div class="flex">
                                      <textarea
                                        class="form-field h-20"
                                        rows="4"
                                        placeholder="Enter up to 1000 words"
                                        v-model="mdV2description"
                                      ></textarea>
                                      <div
                                        v-if="
                                          (!mdV2description ||
                                            mdV2description === '') &&
                                          showMdV2Error
                                        "
                                        class="text-sm mt-1 text-danger-100"
                                      >
                                        Please enter up to 1000 word
                                      </div>
                                      <div
                                        v-if="
                                          mdV2description &&
                                          mdV2description.split(' ').length >
                                            1000
                                        "
                                        class="text-sm mt-1 text-danger-100"
                                      >
                                        Maximum 1000 words
                                      </div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div>
                                      <input
                                        type="text"
                                        class="form-field"
                                        id="topicNamingSpot"
                                        :placeholder="
                                          (selectedAIPrompt &&
                                            aiPrompts[selectedAIPrompt][
                                              'topicPlaceholder'
                                            ]) ||
                                          ''
                                        "
                                        :value="topicNamingSpot[key] || ''"
                                        @change="
                                          handleTopicNamingSpotChanges(
                                            key,
                                            $event
                                          )
                                        "
                                        @input="
                                          handleTopicNamingSpotChanges(
                                            key,
                                            $event
                                          )
                                        "
                                        autocomplete="off"
                                        @focus="showResultsSuggestion"
                                        v-click-outside="hideEMQSuggestion"
                                      />
                                    </div>
                                    <DropdownSuggestions
                                      :onOnSelect="selectEMQNS"
                                      :show="showSuggestedEMQ"
                                      :results="suggestedReports"
                                      :promptID="key"
                                      :mode="mode"
                                    />
                                  </template>
                                </div>
                                <di
                                  v-if="
                                    selectedAIPrompt !== 'url' &&
                                    selectedAIPrompt !== 'h1v2' &&
                                    selectedAIPrompt !== 'mdv2'
                                  "
                                >
                                  <div>
                                    <label
                                      v-if="selectedAIPrompt === 'h1'"
                                      for="keyword"
                                      class="text-[15px] mb-1 block"
                                    >
                                      {{
                                        topicNamingSpot[key] && reportUUID
                                          ? "AI chosen winning words"
                                          : "Manually enter in your keywords"
                                      }}
                                    </label>
                                    <input
                                      type="text"
                                      class="form-field"
                                      id="keyword"
                                      :placeholder="
                                        (selectedAIPrompt &&
                                          aiPrompts[selectedAIPrompt][
                                            'keywordPlaceholder'
                                          ]) ||
                                        ''
                                      "
                                      :value="keyword[key] || ''"
                                      @change="
                                        handleKeywordsChanges(key, $event)
                                      "
                                    />
                                  </div>
                                </di>
                                <template v-if="selectedAIPrompt === 'md'">
                                  <div>
                                    <div>
                                      <label
                                        for="angle"
                                        class="text-[15px] mb-1 block"
                                        >Angle</label
                                      >
                                      <input
                                        type="text"
                                        class="form-field"
                                        id="angle"
                                        v-model="metaDescriptonAngle"
                                        placeholder="Let AI decide, OR enter angle e.g: sale on, info, guide, review, ecommerce, etc"
                                      />
                                    </div>
                                  </div>
                                  <div>
                                    <label
                                      for="perks"
                                      class="text-[15px] mb-1 block"
                                      >Perks</label
                                    >
                                    <input
                                      type="text"
                                      class="form-field"
                                      id="perks"
                                      v-model="metaDescriptonPerks"
                                      placeholder="Let AI decide OR enter perks e.g: 25% off, free parking, buy one get one free, etc"
                                    />
                                  </div>
                                  <div>
                                    <label
                                      for="sales"
                                      class="text-[15px] mb-1 block"
                                      >Sales</label
                                    >
                                    <div class="relative flex items-center">
                                      <select
                                        class="form-field appearance-none"
                                        id="sales"
                                        v-model="metaDescriptonSales"
                                      >
                                        <option value="Top of Funnel">
                                          Top of Funnel
                                        </option>
                                        <option value="Middle of Funnel">
                                          Middle of Funnel
                                        </option>
                                        <option value="Bottom of Funnel">
                                          Bottom of Funnel
                                        </option>
                                      </select>
                                      <span
                                        class="absolute right-4 pointer-events-none"
                                        ><ChevronDown
                                          :size="18"
                                          :stroke-width="1.75"
                                      /></span>
                                    </div>
                                  </div>
                                </template>
                              </div>
                              <div class="flex-1">
                                <Multiselect
                                  v-model="language"
                                  :options="languages"
                                  placeholder="Choose language"
                                  :searchable="true"
                                  :canDeselect="true"
                                  class="form-field"
                                ></Multiselect>
                              </div>
                            </div>
                          </template>
                        </template>
                      </div>
                    </div>
                  </template>
                  <template v-if="activeSection === tabs.QueryIntentFinder">
                    <div class="flex items-center gap-4 xs:flex-col">
                      <div class="flex-1 xs:w-full">
                        <label for="q" class="text-[15px] mb-1 block">Q</label>
                        <div class="relative">
                          <input
                            type="text"
                            class="form-field"
                            id="Topic"
                            placeholder="Exact match query (EMQ)"
                            v-model="topic"
                            @focus="showResultsSuggestion"
                            v-click-outside="hideEMQSuggestion"
                            autocomplete="off"
                          />
                          <DropdownSuggestions
                            :onOnSelect="selectEMQ"
                            :show="showSuggestedEMQ"
                            :results="suggestedReports"
                            :mode="mode"
                          />
                        </div>
                      </div>
                      <div class="flex-1 xs:w-full" v-if="selectedEMQ">
                        <label for="h" class="text-[15px] mb-1 block">H</label>
                        <input
                          type="text"
                          class="form-field"
                          id="h"
                          name="h"
                          placeholder="Top keywords"
                          :value="keyword['100'] || ''"
                          @change="handleKeywordsChanges('100', $event)"
                        />
                      </div>
                      <div class="flex-1 xs:w-full">
                        <label for="answer" class="text-[15px] mb-1 block"
                          >A</label
                        >
                        <input
                          type="text"
                          class="form-field"
                          id="answer"
                          rows="3"
                          disabled
                          placeholder="Submit to generate answer"
                        />
                      </div>
                      <div class="flex-1 xs:w-full">
                        <label for="answer" class="text-[15px] mb-1 block"
                          >Language</label
                        >
                        <Multiselect
                          v-model="language"
                          :options="languages"
                          placeholder="Choose language"
                          :searchable="true"
                          :canDeselect="true"
                          class="form-field"
                        ></Multiselect>
                      </div>
                    </div>
                  </template>
                  <template v-if="activeSection === tabs.OutlineSubheaders">
                    <div class="grid gap-4">
                      <div>
                        <label
                          class="text-[15px] mb-1 inline-flex items-center"
                          v-tooltip="{
                            content: `<div style='max-width: 350px'>Enter your own parent heading to generate highly topical sub-headers (max 3). Use the DOM vector H2-H6 recommendations for optimal results & boosts!</div>`,
                            html: true,
                            distance: 10,
                          }"
                        >
                          Generate new subheadings
                          <Info :size="18" :stroke-width="1.75" class="ml-1" />
                        </label>
                        <div class="flex">
                          <textarea
                            class="form-field h-[100px]"
                            rows="2"
                            placeholder="Enter parent heading"
                            v-model="parentHeading"
                          ></textarea>
                        </div>
                        <div
                          v-if="
                            (!parentHeading || parentHeading === '') &&
                            showParentHeadingError
                          "
                          class="text-sm mt-1 text-danger-100"
                        >
                          Please enter parent heading
                        </div>
                      </div>
                      <div class="flex items-center gap-4">
                        <div class="flex-1">
                          <div class="relative">
                            <input
                              type="text"
                              class="form-field"
                              id="Topic"
                              placeholder="Exact match query (EMQ)"
                              v-model="topic"
                              @focus="showResultsSuggestion"
                              v-click-outside="hideEMQSuggestion"
                              autocomplete="off"
                            />
                            <DropdownSuggestions
                              :onOnSelect="selectEMQ"
                              :show="showSuggestedEMQ"
                              :results="suggestedReports"
                              :mode="mode"
                            />
                            <div
                              v-if="
                                (!selectedEMQ || selectedEMQ === '') &&
                                showSelectQueryError
                              "
                              class="text-sm text-danger-100 mt-1"
                            >
                              Please select an EMQ
                            </div>
                          </div>
                        </div>
                        <div class="flex-1">
                          <Multiselect
                            v-model="language"
                            :options="languages"
                            placeholder="Choose language"
                            :searchable="true"
                            :canDeselect="true"
                            class="form-field"
                          ></Multiselect>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="activeSection === tabs.TopicalCluster">
                    <div class="flex items-center gap-4">
                      <div class="relative flex-1">
                        <input
                          type="text"
                          class="form-field"
                          id="topicalCluster"
                          placeholder="Select/Enter an EMQ"
                          v-model="topic"
                          autocomplete="off"
                          @focus="showResultsSuggestion"
                          v-click-outside="hideEMQSuggestion"
                        />
                        <div
                          v-if="
                            (!topic || topic === '') &&
                            showTopicalClusterQueryError
                          "
                          class="text-sm text-danger-100 mt-1"
                        >
                          Please select/enter an EMQ
                        </div>
                        <DropdownSuggestions
                          :onOnSelect="selectEMQ"
                          :show="showSuggestedEMQ"
                          :results="suggestedReports"
                          promptID="30"
                          :mode="mode"
                        />
                      </div>
                      <div class="flex-1">
                        <Multiselect
                          v-model="language"
                          :options="languages"
                          placeholder="Choose language"
                          :searchable="true"
                          :canDeselect="true"
                          class="form-field"
                        ></Multiselect>
                      </div>
                    </div>
                  </template>
                  <div
                    class="flex items-center justify-end mt-4"
                    v-if="
                      [
                        tabs.HCUPR,
                        tabs.NamingSpot,
                        tabs.FeaturedSnippet,
                        tabs.QueryIntentFinder,
                        tabs.OutlineSubheaders,
                        tabs.TopicalCluster,
                      ].includes(activeSection)
                    "
                  >
                    <button
                      class="button primary-button"
                      @click="loadResults()"
                    >
                      <CheckCheck :size="20" :stroke-width="1.75" />
                      {{
                        activeSection === tabs.OutlineSubheaders
                          ? "Generate Subheadings"
                          : "Submit"
                      }}
                    </button>
                  </div>
                </div>
                <template v-if="activeSection === tabs.NamingSpot">
                  <AISpyResults
                    v-if="selectedAIPrompt !== 'url'"
                    :selectedDropdown="selectedDropdown"
                    :result="result"
                    :aiPrompts="aiPrompts"
                    :selectedAIPrompt="selectedAIPrompt"
                    :prompts="prompts"
                    :topicNamingSpot="topicNamingSpot"
                    :tab="activeSection"
                    :mode="mode"
                    @loadResults="loadResults"
                    @handleDropdownSelect="handleDropdownSelect"
                    @customDropdownText="customDropdownText"
                    @clear="clearResult"
                  ></AISpyResults>
                  <div
                    class="border rounded-lg"
                    :class="mode === 'dark' ? 'border-dark-50' : ''"
                    v-if="selectedAIPrompt === 'url' && urlResults.length"
                  >
                    <div
                      class="flex items-center border-b px-4 py-2 gap-2"
                      :class="mode === 'dark' ? 'border-dark-50' : ''"
                    >
                      <div
                        class="button primary-button"
                        @click="
                          copyResultToClipboard(urlResults.join('\r\n\r\n'))
                        "
                      >
                        <Clipboard :size="20" :stroke-width="1.75" />
                        Copy all results to clipboard
                      </div>
                      <div
                        class="button bg-danger-100 hover:brightness-125"
                        @click="urlResults = []"
                      >
                        <Eraser :size="20" :stroke-width="1.75" />
                        Clear
                      </div>
                    </div>
                    <div class="grid gap-2 p-4">
                      <div
                        class="border rounded-lg p-3"
                        :class="
                          mode === 'dark'
                            ? 'border-dark-50 bg-dark-70'
                            : 'bg-gray-20 bg-opacity-40'
                        "
                        v-for="(resl, index) in urlResults"
                        :key="`url-result-${index}`"
                      >
                        <div class="break-words mb-2 text-[15px]">
                          {{ resl }}
                        </div>
                        <div
                          class="button small-buttton primary-button"
                          @click="copyResultToClipboard(resl)"
                        >
                          <Clipboard :size="20" :stroke-width="1.75" />
                          Copy to clipboard
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div
                v-if="
                  activeTab === 'result' &&
                  [
                    tabs.HCUPR,
                    tabs.FeaturedSnippet,
                    tabs.OutlineSubheaders,
                    tabs.TopicalCluster,
                  ].includes(activeSection)
                "
              >
                <AISpyResults
                  :selectedDropdown="selectedDropdown"
                  :result="result"
                  :aiPrompts="aiPrompts"
                  :selectedAIPrompt="selectedAIPrompt"
                  :prompts="prompts"
                  :topicNamingSpot="topicNamingSpot"
                  :tab="activeSection"
                  :mode="mode"
                  @loadResults="loadResults"
                  @handleDropdownSelect="handleDropdownSelect"
                  @customDropdownText="customDropdownText"
                  @clear="clearResult"
                ></AISpyResults>
              </div>
              <div
                v-if="
                  activeTab === 'result' &&
                  activeSection === tabs.QueryIntentFinder
                "
              >
                <div v-if="answeres.length">
                  <ul
                    v-for="answer in answeres"
                    :key="`QIF-anser-${answer.sl}`"
                    :class="[
                      'grid gap-2',
                      activeSL === answer.sl ? 'active' : '',
                    ]"
                    :data-sl="answer.sl"
                  >
                    <li
                      class="p-3 border rounded-lg text-[15px] flex"
                      :class="
                        mode === 'dark'
                          ? 'border-dark-50 bg-dark-70'
                          : 'bg-opacity-40 bg-gray-20'
                      "
                    >
                      Q: {{ answer.q }}
                    </li>
                    <li
                      class="p-3 border rounded-lg text-[15px] flex"
                      :class="
                        mode === 'dark'
                          ? 'border-dark-50 bg-dark-70'
                          : 'bg-opacity-40 bg-gray-20'
                      "
                    >
                      H: {{ answer.h }}
                    </li>
                    <li
                      class="p-3 border rounded-lg text-[15px] flex"
                      :class="
                        mode === 'dark'
                          ? 'border-dark-50 bg-dark-70'
                          : 'bg-opacity-40 bg-gray-20'
                      "
                    >
                      A:
                      <ul class="list-disc pl-5 grid gap-1">
                        <li
                          v-for="(ans, index) in answerParts(answer.a)"
                          :key="`QIF-part-${answer.sl}-${index}`"
                        >
                          <span class="flex items-center gap-1">
                            {{ dotPad(ans.phrase) }}
                            <Clipboard
                              :size="18"
                              :stroke-width="1.75"
                              class="cursor-pointer"
                              @click="copyAnswer(dotPad(ans.phrase))"
                            />
                          </span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div
                  v-if="total_tokens_used > 0"
                  class="bg-info-50 text-info-100 text-[15px] rounded-lg p-4"
                >
                  Total AI credit used for the last prompt:
                  <span class="font-medium">{{ total_tokens_used }}</span>
                </div>
              </div>
              <div v-if="activeSection === tabs.AdvancedAIDetection">
                <div class="mb-4">
                  <h5 class="font-semibold text-[17px] leading-none mb-1">
                    Publish your content without worry (Copyscape plagiarism
                    offered on Article Builder)
                  </h5>
                  <p
                    class="text-[15px]"
                    :class="mode === 'dark' ? 'text-dark-15' : 'text-gray-600'"
                  >
                    Ensure your content is safe from being flagged as
                    AI-generated. Quickly see your contents Predictable score,
                    Avg Length Predictable and Worst Length Predictable. Keyword
                    Reports compare the top 20 SERP competitors.
                  </p>
                </div>
                <div class="flex items-start justify-between gap-4">
                  <div
                    class="flex-1 border rounded-xl"
                    :class="mode === 'dark' ? 'border-dark-50' : ''"
                  >
                    <CKEditor
                      content=""
                      placeholder="Enter content here (maximum 1000 words roughly 5400-6000 characters)"
                      :mode="mode"
                    />
                    <div class="p-4">
                      <p class="mb-2">
                        <strong>AI Detection 1.0 Disclaimer</strong>
                      </p>
                      <p
                        :class="
                          mode === 'dark' ? 'text-dark-15' : 'text-gray-600'
                        "
                      >
                        As we consistently enhance our AI models to deliver the
                        most accurate AI content detection, we encourage you to
                        incorporate these results as an element of a thorough
                        evaluation for your content and not use this data
                        exclusively. To accurately assess whether your content
                        is AI-generated or not, we highly recommend utilizing
                        the KeywordSpy Report feature. This essential tool
                        provides valuable insights by comparing your content
                        with the top 20 SERP competitors, helping you make a
                        well-informed evaluation.
                      </p>
                    </div>
                  </div>
                  <div class="w-[300px]">
                    <div class="grid gap-2">
                      <div
                        class="flex items-center justify-between border rounded-xl p-3"
                        :class="mode === 'dark' ? 'border-dark-50' : ''"
                      >
                        <span class="text-[15px] font-medium">Predictable</span>
                        <CurrCompData
                          :curr="Number(gltrData?.prob?.toFixed(2) ?? 0)"
                          :best="0.71"
                          :label="false"
                        />
                      </div>
                      <div
                        class="flex items-center justify-between border rounded-xl p-3"
                        :class="mode === 'dark' ? 'border-dark-50' : ''"
                      >
                        <span class="text-[15px] font-medium"
                          >Avg Predictability Length</span
                        >
                        <CurrCompData
                          :curr="
                            Number(gltrData?.avg_topk_lengths?.toFixed(2) ?? 0)
                          "
                          :best="4.1"
                          :label="false"
                        />
                      </div>
                      <div
                        class="flex items-center justify-between border rounded-xl p-3"
                        :class="mode === 'dark' ? 'border-dark-50' : ''"
                      >
                        <span class="text-[15px] font-medium"
                          >Worst Predictability Length</span
                        >
                        <CurrCompData
                          :curr="
                            Number(
                              gltrData?.worst_topk_lengths?.toFixed(2) ?? 0
                            )
                          "
                          :best="22"
                          :label="false"
                        />
                      </div>
                      <div
                        class="border rounded-xl p-3"
                        :class="mode === 'dark' ? 'border-dark-50' : ''"
                        v-if="aiResult"
                      >
                        <h6
                          class="font-medium text-[15px] mb-1"
                          v-tooltip="{
                            content: `<div style='max-width: 300px;'>This prediction is based off of writing style only, it can be a good way to break ties as to whether the content was AI generated but is easy to fool alone. </div>`,
                            html: true,
                          }"
                        >
                          Predictable writing style detector
                        </h6>
                        <span class="text-[15px] block mb-2">
                          {{ aiResult }}
                        </span>
                        <p
                          class="text-[15px]"
                          :class="
                            mode === 'dark' ? 'text-dark-15' : 'text-gray-600'
                          "
                        >
                          NOTE: If your writing is predictable and boring, this
                          might be an issue for more than just Google
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="activeSection === tabs.ContentImprover"
                class="flex flex-col gap-4"
              >
                <div class="grid gap-4">
                  <div
                    class="bg-info-50 text-info-100 text-[15px] rounded-lg p-3"
                  >
                    Improve your copy to use less words and less oft-used words.
                    AI spy will convert your copy to active tense and insert
                    more captivating words to sound smarter.
                  </div>
                  <div class="grid gap-4">
                    <div>
                      <input
                        type="text"
                        class="form-field"
                        id="Topic"
                        placeholder="Enter a main topic / keyword to help improve your copy"
                        v-model="topic"
                        @change="handleTopicChange"
                        @focus="showResultsSuggestion"
                        v-click-outside="hideEMQSuggestion"
                        autocomplete="off"
                      />
                      <div class="text-sm text-danger-100 mt-1" v-if="!topic">
                        {{ error.contentImprover.topic }}
                      </div>
                    </div>
                    <div>
                      <div class="flex">
                        <textarea
                          class="form-field h-[400px]"
                          placeholder="Enter text to improve (max 500 words)"
                          v-model="contentToImprove"
                          rows="15"
                        ></textarea>
                      </div>
                      <div
                        class="text-sm text-danger-100 mt-1"
                        v-if="!contentToImprove"
                      >
                        {{ error.contentImprover.contentToImprove }}
                      </div>
                    </div>
                    <div class="flex items-center justify-end">
                      <button
                        class="button primary-button"
                        @click="improveContent"
                      >
                        <CheckCheck :size="20" :stroke-width="1.75" />
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
                <AISpyResults
                  :selectedDropdown="selectedDropdown"
                  :result="result"
                  :aiPrompts="aiPrompts"
                  :selectedAIPrompt="selectedAIPrompt"
                  :prompts="prompts"
                  :topicNamingSpot="topicNamingSpot"
                  :tab="activeSection"
                  :mode="mode"
                  @loadResults="improveContent"
                  @handleDropdownSelect="handleDropdownSelect"
                  @customDropdownText="customDropdownText"
                  @clear="clearResult"
                ></AISpyResults>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/reactivity";
import { useUserStore } from "../stores/user";
import { postPrompt } from "../libs/Api";
import Multiselect from "@vueform/multiselect";
import TopBar from "../components/TopBar.vue";
import AISpyResults from "../components/ai-spy/Results.vue";
import DropdownSuggestions from "../components/common/DropdownSuggestions.vue";
import CKEditor from "../components/gltr/CKEditor.vue";
import CurrCompData from "../components/ce/CurrCompData.vue";
import ApiRequest from "../libs/ApiRequest";
import helper from "../libs/helper";
import { countWords } from "../libs";
import {
  CheckCheck,
  ChevronDown,
  Clipboard,
  Eraser,
  Info,
} from "lucide-vue-next";

export default {
  setup() {
    const userStore = useUserStore();
    return {
      userStore,
      gltrData: computed(() => userStore.gltrData),
      aiResult: computed(() => userStore.aiDetectionResult),
    };
  },
  props: {
    mode: String,
  },
  data() {
    return {
      activeTab: "prompt",
      topic: "",
      keyword: {},
      topicNamingSpot: {},
      prompts: {},
      promptKeys: [],
      checkedPrompts: [],
      result: {},
      selectedDropdown: {},
      aiPrompts: {},
      selectedAIPrompt: null,
      tabs: {
        HCUPR: "Google HCU/Review AI",
        NamingSpot: "URL/Title/Meta/H1",
        AdvancedAIDetection: "AI Detection 1.0",
        ContentImprover: "Content Improver",
        FeaturedSnippet: "Win Featured Snippet",
        OutlineSubheaders: "Outline/Subheaders",
        QueryIntentFinder: "Query Intent Finder",
        TopicalCluster: "Topical Cluster",
      },
      activeSection: "",
      reportUUID: "",
      reports: [],
      showSuggestedEMQ: false,
      suggestedReports: [],
      contentToImprove: "",
      error: {
        contentImprover: {},
      },
      metaDescriptonAngle: null,
      metaDescriptonPerks: null,
      metaDescriptonSales: "",
      urlResults: [],
      showSelectQueryError: false,
      selectedEMQ: null,
      parentHeading: null,
      showParentHeadingError: false,
      QHAObj: {},
      activeSL: 0,
      answeres: [],
      total_tokens_used: 0,
      mdV2description: "",
      showMdV2Error: false,
      showTopicalClusterQueryError: false,
      languages: [],
      language: "",
    };
  },
  watch: {
    selectedAIPrompt(val) {
      this.showMdV2Error = false;
      this.showSelectQueryError = false;
      this.$router.replace({
        query: { active_tab: this.$route.query.active_tab, ai_prompt: val },
      });
    },
    mdV2description(val) {
      if (val && val.split(" ").length > 1000) {
        this.mdV2description = this.mdV2description
          .split(" ")
          .splice(0, 1000)
          .join(" ");
      }
    },
    topic(val) {
      this.loadReports(val);
    },
    topicNamingSpot() {
      this.getWordsComparison();
    },
  },
  mounted() {
    this.userStore.setIsLoading(!1);
    this.getAIPrompts();
    this.reportUUID = this.$route.params.uuid || "";
    this.selectedEMQ = this.reportUUID;
    this.activeSection = this.$route.query.active_tab || this.tabs.HCUPR;
    this.selectedAIPrompt = this.$route.query.ai_prompt || "";
    this.resetAnswers();
    this.getLanguages();
    if (
      this.selectedAIPrompt &&
      this.aiPrompts &&
      Object.keys(this.aiPrompts).includes(this.selectedAIPrompt)
    ) {
      this.checkedPrompts = ["14"];
    }
    if (this.activeSection === this.tabs.FeaturedSnippet) {
      this.checkedPrompts = ["25"];
    }
    if (this.activeSection === this.tabs.TopicalCluster) {
      this.checkedPrompts = ["30"];
    }
    if (this.activeSection === this.tabs.QueryIntentFinder) {
      this.checkedPrompts = ["100"];
    }
    if (this.activeSection === this.tabs.OutlineSubheaders) {
      this.checkedPrompts = ["18"];
    }
    this.loadPrompts();
    this.loadReports();
    if (this.reportUUID) {
      this.loadSearchResult();
    }
  },
  components: {
    TopBar,
    AISpyResults,
    DropdownSuggestions,
    CKEditor,
    Multiselect,
    CurrCompData,
    Info,
    ChevronDown,
    CheckCheck,
    Clipboard,
    Eraser,
  },
  methods: {
    async getLanguages() {
      const { extractedError, languages: apiLanguages } =
        await this.userStore.getSupportedInfo();
      if (extractedError) {
        $toast.error(extractedError.alert.message);
      }
      this.languages = apiLanguages;
    },
    async copyAnswer(text) {
      await new Promise((resolve) => setTimeout(resolve, 1));
      this.resetAnswers();
      const { alertType, message } = await helper.copyToClipboard(text);
      if (alertType === "error") {
        this.$toast.error(message);
      } else {
        this.$toast.success(message);
      }
    },
    answerParts(ans) {
      if (!ans) return [];
      return ans;
    },
    dotPad(str) {
      if (str.charAt(str.length - 1) != ".") {
        str = str + ".";
      }
      return str;
    },
    async copyResultToClipboard(item) {
      const { alertType, message } = await helper.copyToClipboard(item);
      if (alertType === "error") {
        this.$toast.error(message);
      } else {
        this.$toast.success(message);
      }
    },
    resetPromptsAndDropdown() {
      this.checkedPrompts = [];
      this.selectedDropdown = {};
      this.activeTab = "prompt";
    },
    setActiveTab(name) {
      this.activeTab = name;
    },
    setActiveSection(name) {
      this.topic = "";
      this.activeSection = name;
      this.showSelectQueryError = false;
      this.showTopicalClusterQueryError = false;
      this.resetPromptsAndDropdown();
      this.result = {};
      this.answeres = [];
      this.$router.replace({ query: { active_tab: name } });
      if (this.activeSection === this.tabs.ContentImprover) {
        this.checkedPrompts = ["17"];
      }
      if (this.activeSection === this.tabs.FeaturedSnippet) {
        this.checkedPrompts = ["25"];
      }
      if (this.activeSection === this.tabs.QueryIntentFinder) {
        this.checkedPrompts = ["100"];
      }
      if (this.activeSection === this.tabs.OutlineSubheaders) {
        this.checkedPrompts = ["18"];
      }
      if (this.activeSection === this.tabs.TopicalCluster) {
        this.checkedPrompts = ["30"];
      }
    },
    handleTopicChange() {
      this.selectedDropdown = {};
      this.result = {};
      this.suggestedReports = this.reports.filter((report) =>
        report.query.includes(this.topic)
      );
    },
    handleTopicNamingSpotChanges(promptID, event) {
      this.topicNamingSpotChanged(promptID, event.target.value);
      this.showSuggestedEMQ = true;
    },
    topicNamingSpotChanged(promptID, val) {
      this.selectedDropdown = {};
      this.topicNamingSpot = {
        ...this.topicNamingSpot,
        ...{ [promptID]: val },
      };
      this.suggestedReports = this.reports.filter((report) =>
        report.query.includes(val)
      );
    },
    handleKeywordsChanges(promptID, event) {
      this.selectedDropdown = {};
      this.keyword = { ...this.keyword, ...{ [promptID]: event.target.value } };
    },
    async loadPrompts() {
      try {
        const res = await ApiRequest().get("/api/zebraai/prompts");
        if (res.status !== 200) {
          throw new Error("Something went wrong!");
        }
        this.prompts = res.data.prompts;
        this.promptKeys = Object.keys(this.prompts);
      } catch (error) {
        this.userStore.setIsLoading(!1);
        const extractedError = helper.extractAlert(error, "zebra-ai");
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      }
    },
    getAIPrompts() {
      this.aiPrompts = {
        url: {
          name: "URL",
          topicPlaceholder: "Exact Match Query (EMQ)",
          keywordPlaceholder: "Keywords",
        },
        tt: {
          name: "Title Tag",
          topicPlaceholder: "Topic/Search Query: (ex. Hanauma bay parking)",
          keywordPlaceholder: "Keywords",
        },
        md: {
          name: "Meta Description",
          topicPlaceholder:
            "Topic/Search Query: (ex. Get all the Tips about Parking at Hanauma Bay State Park)",
          keywordPlaceholder: "Keywords",
        },
        h1: {
          name: "H1",
          topicPlaceholder: "Topic/Search Query: (ex. Hanauma bay parking)",
          keywordPlaceholder: "Keywords",
        },
        mdv2: {
          name: "Meta Description (version 2)",
          topicPlaceholder:
            "Topic/Search Query: (ex. Get all the Tips about Parking at Hanauma Bay State Park)",
          keywordPlaceholder: "Keywords",
        },
        h1v2: {
          name: "H1 (version 2)",
          topicPlaceholder: "Topic/Search Query: (ex. Hanauma bay parking)",
          keywordPlaceholder: "Keywords",
        },
      };
    },
    async loadURLResults() {
      const results = await ApiRequest().post("/api/zebraai/url_prompt", {
        uuid: this.selectedEMQ,
      });
      this.urlResults.push(results.data.result);
      this.showSelectQueryError = false;
    },
    resetAnswers() {
      this.activeSL = this.answeres.length + 1;
      this.QHAObj = {
        q: this.topic,
        h: "",
        a: "",
      };
    },
    async generateAnswer() {
      this.userStore.setIsLoading(!0);
      try {
        const promptObj = {
          search_query: this.topic,
          prompt_id: "100",
          search_words: this.keyword["100"],
          uuid: this.selectedEMQ,
          previous_result: "",
          drop_down: "",
        };
        const URL = "/api/v2/zebraai/prompt-result";
        const res = await ApiRequest().post(URL, { prompts: [promptObj] });
        if (res.status !== 200) {
          throw new Error("Something went wrong!");
        }
        const a = (res.data && res.data.result["100"]?.result) || "";
        this.total_tokens_used =
          (res.data && res.data.result["100"]?.total_tokens_used) || 0;
        const answeres = this.answeres.filter(
          (ans) => ans.sl !== this.activeSL
        );
        answeres.push({
          q: this.topic,
          h: this.keyword["100"],
          a,
          sl: this.activeSL,
        });
        this.answeres = helper.lodashOrder(answeres, "sl", true);
        this.resetAnswers();
        this.setActiveTab("result");
      } catch (error) {
        const extractedError = helper.extractAlert(error, "zebra-ai");
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      } finally {
        this.userStore.setIsLoading(!1);
      }
    },
    async loadResults(loadForpromptID = null) {
      this.userStore.setIsLoading(!0);
      try {
        if (this.checkedPrompts.length < 1) {
          throw new Error("Please select prompt");
        }
        if (
          this.checkedPrompts.length > 4 &&
          this.activeSection === this.tabs.HCUPR
        ) {
          throw new Error("Please select 4 or less prompts");
        }
        if (this.checkedPrompts[0] === "14") {
          if (
            this.selectedAIPrompt === "mdv2" &&
            (!this.mdV2description ||
              (this.mdV2description &&
                this.mdV2description.split(" ").length > 1000))
          ) {
            this.showMdV2Error = true;
            this.mdV2description = this.mdV2description
              .split(" ")
              .splice(0, 1000)
              .join(" ");
          }
          if (
            !this.selectedEMQ &&
            (this.selectedAIPrompt === "url" ||
              this.selectedAIPrompt === "h1v2")
          ) {
            this.showSelectQueryError = true;
            throw new Error("Exact Match Query (EMQ) can not be empty");
          }
          if (this.selectedAIPrompt === "url") {
            await this.loadURLResults();
            this.userStore.setIsLoading(!1);
            return;
          }
        }
        if (
          this.checkedPrompts[0] === "100" &&
          this.activeSection === this.tabs.QueryIntentFinder
        ) {
          if (!this.topic) {
            this.showSelectQueryError = true;
            throw new Error("Exact Match Query (EMQ) can not be empty");
          }
          await this.generateAnswer();
          this.selectedEMQ = "";
          this.userStore.setIsLoading(!1);
          return;
        }
        if (
          this.checkedPrompts[0] === "18" &&
          this.activeSection === this.tabs.OutlineSubheaders
        ) {
          if (!this.parentHeading) {
            this.showParentHeadingError = true;
            throw new Error("Parent heading can not be empty");
          }
          if (!this.selectedEMQ) {
            this.showSelectQueryError = true;
            throw new Error("Exact Match Query (EMQ) can not be empty");
          }
        }
        if (
          this.checkedPrompts[0] === "30" &&
          this.activeSection === this.tabs.TopicalCluster
        ) {
          if (!this.topic) {
            this.showTopicalClusterQueryError = true;
            throw new Error("EMQ can not be empty");
          }
        }
        const prompts = [];
        for (let i = 0; i < this.checkedPrompts.length; i++) {
          const promptID = this.checkedPrompts[i];
          const promptData = this.prompts[promptID];
          if (
            promptData.type === "AI" &&
            !this.topicNamingSpot[promptID] &&
            !this.selectedAIPrompt == "mdv2"
          ) {
            throw new Error("Search query can not be empty for Naming Spots");
          }
          if (promptData.type !== "AI" && !this.topic) {
            throw new Error("Please add a search query.");
          }
          const dropdownObj = this.selectedDropdown[loadForpromptID]
            ? this.selectedDropdown[loadForpromptID]
            : false;
          let dropdown = "";
          if (dropdownObj) {
            if (dropdownObj.index === 1) {
              dropdown = `Tell me more about this`;
            }
            if (dropdownObj.index === 2) {
              if (!dropdownObj.customText) {
                throw new Error("Please add custom text");
              }
              dropdown = `Tell me more about ${dropdownObj.customText}`;
            }
            if (dropdownObj.index === 3) {
              if (!dropdownObj.customText) {
                throw new Error("Please add custom text");
              }
              dropdown = `Explain how ${dropdownObj.customText} works`;
            }
            if (dropdownObj.index === 4) {
              dropdown = `What are more interesting tips, info and helpful comments on this`;
            }
            if (dropdownObj.index === 5) {
              dropdown = `What do lay people say about this topic as compared to what the experts say`;
            }
          }
          let previous_result =
            this.result[promptID]?.result[
              this.result[promptID]?.result.length - 1
            ];
          if (promptID === "14") {
            previous_result = "";
          }
          const promptObj = {
            search_query: this.topic,
            prompt_id: promptID,
            previous_result: previous_result,
            drop_down: dropdown,
            search_words: "",
            uuid: this.reportUUID,
            ...(this.language && this.language !== ""
              ? { language: this.language }
              : {}),
          };
          if (promptID === "14" && this.selectedAIPrompt == "md") {
            promptObj.prompt_id = "24";
            promptObj.angle = this.metaDescriptonAngle || "";
            promptObj.perks = this.metaDescriptonPerks || "";
            promptObj.sales = this.metaDescriptonSales || "";
          }
          if (promptData.type === "AI") {
            promptObj.search_query = this.topicNamingSpot[promptID];
            promptObj.search_words = this.keyword[promptID];
          }
          if (promptID === "18") {
            promptObj.uuid = this.selectedEMQ;
            promptObj.content = this.parentHeading;
          }
          if (promptID === "14" && this.selectedAIPrompt == "mdv2") {
            promptObj.prompt_id = "32";
            promptObj.content = this.mdV2description;
            promptObj.search_query = "";
          }
          if (promptID === "14" && this.selectedAIPrompt == "h1v2") {
            promptObj.prompt_id = "31";
          }
          if (
            promptID === "30" &&
            this.activeSection === this.tabs.TopicalCluster
          ) {
            promptObj.prompt_id = "30";
            promptObj.uuid = "";
            promptObj.previous_result = "";
          }
          prompts.push(promptObj);
        }
        const URL = "/api/zebraai/prompt-result";
        const res = await ApiRequest().post(URL, { prompts });
        if (res.status !== 200) {
          throw new Error("Something went wrong!");
        }
        if (res.data?.result) {
          const resultKeys = Object.keys(res.data.result);
          const finalResults = {};
          for (const resultKey of resultKeys) {
            const newResult = res.data.result[resultKey];
            let resultText = newResult.result;
            if (resultKey === "14") {
              resultText = `${this.topicNamingSpot["14"]}: ${resultText}`;
            }
            const oldResults = this.result[resultKey]?.result || [];
            finalResults[resultKey] = {
              total_tokens_used: newResult["total_tokens_used"] || 0,
              result: [...oldResults, resultText],
            };
            if (resultKey === "30") {
              finalResults[resultKey] = {
                total_tokens_used: newResult["total_tokens_used"] || 0,
                result: [resultText],
                topical_cluster_emqs: newResult["topical_cluster_emqs"] || [],
              };
            }
            if (resultKey === "18") {
              finalResults[resultKey] = {
                total_tokens_used: newResult["total_tokens_used"] || 0,
                result: [...newResult["headings"]],
              };
            }
          }
          if (loadForpromptID) {
            this.result = { ...this.result, ...finalResults };
          } else {
            this.result = finalResults;
          }
          if (
            this.activeSection === this.tabs.HCUPR ||
            this.activeSection === this.tabs.FeaturedSnippet ||
            this.activeSection === this.tabs.TopicalCluster ||
            this.activeSection === this.tabs.OutlineSubheaders
          ) {
            this.setActiveTab("result");
          }
        }
        this.userStore.setIsLoading(!1);
      } catch (error) {
        this.userStore.setIsLoading(!1);
        const extractedError = helper.extractAlert(error, "zebra-ai");
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      }
    },
    handlePromptChanged(event) {
      this.selectedDropdown = {};
      if (event.target.checked) {
        this.checkedPrompts = [...this.checkedPrompts, event.target.value];
      } else {
        this.checkedPrompts = this.checkedPrompts.filter(
          (prompt) => prompt != event.target.value
        );
      }
    },
    handleAIPromptChanged(prompt, event) {
      this.selectedAIPrompt = prompt;
      this.selectedDropdown = {};
      if (event.target.checked) {
        this.checkedPrompts = [event.target.value];
      } else {
        this.checkedPrompts = this.checkedPrompts.filter(
          (prompt) => prompt != event.target.value
        );
      }
    },
    handleDropdownSelect(promptID, index) {
      const newItem = {
        [promptID]: {
          index,
          customText: "",
        },
      };
      this.selectedDropdown = newItem;
    },
    customDropdownText(promptID, index, event) {
      const newItem = {
        [promptID]: {
          index,
          customText: event.target.value,
        },
      };
      this.selectedDropdown = newItem;
    },
    async getWordsComparison() {
      this.userStore.setIsLoading(!0);
      try {
        let totalWordsToJoin = 7;
        let URLEnding = "words_comparison";
        if (this.selectedAIPrompt === "md") {
          totalWordsToJoin = 10;
          URLEnding = "meta_description";
        }
        const URL = `/api/analyses/token-analyses/${this.reportUUID}/reports/${URLEnding}`;
        const res = await ApiRequest().get(URL);
        if (res.status !== 200) {
          throw new Error("Something went wrong");
        }
        let words = [];
        const tokens = [];
        let emqWards = [];
        if (this.selectedAIPrompt === "md") {
          if (Array.isArray(res.data.meta_description)) {
            words = helper.lodashOrder(
              res.data.meta_description,
              "score",
              "desc"
            );
          }
        } else {
          if (Array.isArray(res.data.result)) {
            words = helper.lodashOrder(res.data.result, "total_score", "desc");
          }
          emqWards = this.topicNamingSpot["14"].toLowerCase().split(" ");
        }
        for (let i = 0; i < words.length; i++) {
          const token = words[i].token;
          if (token === "" || emqWards.includes(token)) {
            continue;
          }
          tokens.push(token);
          if (tokens.length === totalWordsToJoin) {
            break;
          }
        }
        this.keyword = { [this.checkedPrompts[0]]: tokens.join(", ") };
      } catch (error) {
        const extractedError = helper.extractAlert(error, "nm");
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      } finally {
        this.userStore.setIsLoading(!1);
      }
    },
    async loadSearchResult() {
      this.userStore.setIsLoading(!0);
      try {
        const res = await ApiRequest().get(
          `/api/serp/search/${this.reportUUID}`
        );
        if (res.status !== 200) {
          throw new Error("Something went wrong!");
        }
        this.topic = res.data.query;
        this.language = res.data.language || "";
        this.topicNamingSpot = { ["14"]: this.topic };
      } catch (error) {
        const extractedError = helper.extractAlert(error, "projects");
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      } finally {
        this.userStore.setIsLoading(!1);
      }
    },
    async loadReports(filter = "") {
      try {
        const { data } = await ApiRequest().get(
          `/api/serp/search?page=1&is_archive=false&filter=${filter}`
        );
        const { results = [] } = data;
        this.reports = helper.lodashOrder(results, "created_at", "desc");
        this.suggestedReports = this.reports;
      } catch (error) {
        const extractedError = helper.extractAlert(error, "reports");
        this.$toast.error(extractedError.alert.message);
        if (extractedError.redirect) {
          this.userStore.signOut();
          this.$router.push({ name: extractedError.redirect });
        }
      }
    },
    showResultsSuggestion() {
      this.showSuggestedEMQ = true;
    },
    hideEMQSuggestion() {
      this.showSuggestedEMQ = false;
    },
    selectEMQ(report) {
      this.topic = report.query;
      this.$router.push({
        name: "zebra-ai",
        params: { uuid: report.uuid },
        query: {
          active_tab: this.activeSection,
          ...(this.selectedAIPrompt
            ? { ai_prompt: this.selectedAIPrompt }
            : {}),
        },
      });
    },
    handleSelectEMQ(uuid) {
      if (!uuid) return;
      this.$router.push({
        name: "zebra-ai",
        params: { uuid: uuid },
        query: {
          active_tab: this.activeSection,
          ...(this.selectedAIPrompt
            ? { ai_prompt: this.selectedAIPrompt }
            : {}),
        },
      });
    },
    selectEMQNS(report, key) {
      this.showSuggestedEMQ = false;
      this.reportUUID = report.uuid;
      this.topicNamingSpotChanged(key, report.query);
    },
    async improveContent() {
      try {
        this.userStore.setIsLoading(true);
        let hasError = false;
        this.error.contentImprover = {};
        if (!this.topic) {
          hasError = true;
          this.error.contentImprover.topic =
            "Topic or keyword can not be empty";
        }
        if (!this.contentToImprove) {
          hasError = true;
          this.error.contentImprover.contentToImprove =
            "Content can not be empty";
        }
        const count = countWords(this.contentToImprove);
        if (count > 500) {
          hasError = true;
          this.error.contentImprover.contentToImprove = `Content can not be more than 500 words. You have ${count} words`;
        }
        if (hasError) {
          return;
        }
        const prompt = {
          search_query: this.topic,
          prompt_id: "17",
          previous_result: "",
          drop_down: "",
          search_words: "",
          uuid: this.reportUUID || "",
          content: this.contentToImprove,
        };
        const postData = {
          prompts: [prompt],
        };
        const { data } = await postPrompt(postData);
        if (data?.result) {
          const resultKeys = Object.keys(data.result);
          const finalResults = {};
          for (const resultKey of resultKeys) {
            const newResult = data.result[resultKey];
            const oldResults = this.result[resultKey]?.result || [];
            finalResults[resultKey] = {
              total_tokens_used: newResult["total_tokens_used"] || 0,
              result: [...oldResults, newResult.result],
            };
          }
          this.result = finalResults;
        }
      } catch (err) {
        const extractedError = helper.extractAlert(err);
        this.$toast.error(extractedError.alert.message);
      } finally {
        this.userStore.setIsLoading(false);
      }
    },
    clearResult() {
      this.result = {};
      this.selectedDropdown = {};
      this.setActiveTab("prompt");
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.scss"></style>
